// extracted by mini-css-extract-plugin
export default {"PageLoading":"index_PageLoading__CdTyt"};